import React from "react";
import { Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import ContentSection from "../../../../components/common/content-section";
import VimeoVideo from "../../../../components/common/vimeo-video";

const What = () => {
  return (
    <ContentSection>
      <Row>
        <Col className="mb-4">
          <h1>Maintenance &amp; Release Announcement: 05 Sept 23</h1>
          <p>
            Microsoft has now announced that an impending update to Windows 11
            will impact software utilising internet security protocols
            TLS1/TLS2, whereby users who install this update will be unable to
            access our existing licence server. We have been ahead of this
            expected change for some time and have developed new licencing
            software that will both address this issue and adapt more readily to
            future changes.
          </p>
          <p>
            Microsoft has announced this change will occur soon (without a
            definite date), so we will act to bring forward the release of our
            new licencing software and our new version of XerTransfer in one
            step.
          </p>
          <p>
            Many of you know we have been working hard on a new version,
            bringing XerTransfer into a new maturity phase with deeper and more
            accurate conversion capability. Working collectively and
            collaboratively with our corporate and website user cohort to
            develop XerTransfer further, we are very excited to release our next
            phase to XerTransfer, incorporating an additional 36 months of
            development.
          </p>
          <p>
            We will be finalising our release procedures in the coming days and
            will provide further information regarding the release, any
            necessary licencing transition and additional steps that may need to
            be taken by users, ensuring the least disruption.
          </p>
          <p>
            We recognise that many may have recently renewed, have onboarded
            XerTransfer, or are part way through an evaluation, and we extend in
            advance our apologies for the timing. This update will benefit all
            XerTransfer users, and we hope the benefits will outweigh any
            temporary disruptions.
          </p>
          <p>
            Users are welcome to contact{" "}
            <a href="mailto:admin@xertransfer.com">admin@xertransfer.com</a> to
            discuss your needs across the transition.
          </p>
        </Col>
      </Row>
      <Row>
        <Col md={7}>
          <h1>What is XerTransfer &amp; How does it work?</h1>
          <p>
            <em>
              XerTransfer is a solution based software for the project
              management industry tailored to users of Microsoft Project and
              Oracle Primavera P6 who require the exchange of project data
              between these softwares.
            </em>
          </p>
          <p>
            <em>
              XerTransfer is available as XerTransfer Standard, XerTransfer
              Plus+ and XerTransfer Professional, a three-tier product suite
              servicing advanced data exchange with developed reporting features
              and health check analysis improving interoperability between
              Microsoft Project and Oracle Primavera P6.
            </em>
          </p>
          <p>
            <em>
              XerTransfer is an add-in for Microsoft Project that acts as a
              platform assisting the flow and exchange of project data between
              Microsoft Project and Oracle Primavera P6.
            </em>
          </p>
          <p>
            <em>
              Via XerTransfer an Oracle Primavera P6 .XER file can be directly
              imported into Microsoft Project exchanging Oracle Primavera P6
              project data with a Microsoft Project user.
            </em>
          </p>
          <p>
            <em>
              Via XerTransfer a Microsoft Project .MPP file can be exported as
              an Oracle Primavera P6 .XER file exchanging Microsoft Project data
              with an Oracle Primavera P6 user.
            </em>
          </p>
          <p>
            <em>
              Supporting advanced data exchange of Tasks, Work Breakdown
              Structure, Task Relationships, Relationship Leads and Lags, Task
              Durations, Constraints, Activity Types
            </em>
            , Calendars, User Define Fields with a range of mapping options
            allowing users to selectively map specified data fields for
            conversion between Microsoft Project and Oracle Primavera P6.{" "}
            <em>
              XerTransfer Professional being our premium tool offers our full
              range of data and reporting exchange and includes costs and
              resources conversation capabilities.
            </em>
          </p>
          <p>
            <em>
              As XerTransfer is an add-in tool for Microsoft Project, a user
              will require Microsoft Project. A XerTransfer user does not need
              Oracle Primavera P6 for conversion or to generate, save or open an
              .XER file and a P6 user will not require Microsoft Project or
              XerTransfer to open any .XER file as generated by our tool.
            </em>
          </p>
          <p>
            <em>
              XerTransfer is compatible with Microsoft Project 2013, 2016 and
              2019 and Oracle Primavera P6 Professional.
            </em>
          </p>

          <div className="text-center">
            <a
              href="/we-are-xersolutions/#join-the-xertransfer-community"
              className="sw-btn-std-white mt-2"
              style={{ minWidth: "200px" }}
            >
              Join the XerTransfer Community
            </a>{" "}
            <Link
              to="/trial-xertransfer/"
              className="sw-btn-std-blue mt-2"
              style={{ minWidth: "200px" }}
            >
              Trial XerTransfer Professional Now for Free
            </Link>
          </div>
        </Col>
        <Col md={5} className="mt-3 mt-md-0">
          <VimeoVideo videoUrl="https://player.vimeo.com/video/448397297" />
          <p>
            <strong>Showcase Video XerTransfer Standard</strong>
          </p>
          <p>
            This showcase video demonstrates a high level overview of
            XerTransfer Standard. Refer to our further{" "}
            <Link to="/product/">showcase demonstrations</Link> for products
            XerTransfer Plus+ and XerTransfer Professional for an overview of
            advanced reporting functionality, Quality Analysis Health Check
            process and costs and resources conversion capabilities.
          </p>
        </Col>
      </Row>
    </ContentSection>
  );
};

export default What;
